/** Poll for a new service worker: hourly + whenever the app regains focus.
 *  autoUpdate activates it; the toast in main.tsx offers the reload. */
export function startSwUpdatePolling(
  r: ServiceWorkerRegistration,
  intervalMs = 60 * 60 * 1000,
): () => void {
  const tick = (): void => { void r.update().catch(() => undefined); };
  const id = setInterval(tick, intervalMs);
  const onVis = (): void => { if (document.visibilityState === "visible") tick(); };
  document.addEventListener("visibilitychange", onVis);
  return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
}
